import { gsap } from 'gsap';

export default class ReadMore {

	constructor(el) {
		this.el = el;

        this.button = this.el.querySelector('[data-readmore-toggle-button]');

		if(!this.button) {
			return;
		}

		this.readmoreEl = this.el.querySelector('[data-readmore-collapse]');
		this.itemText = this.readmoreEl.querySelector('.c-module-text');

		this.button.addEventListener('click', () => {
            this.toggle();
        });

		this.tl = gsap.timeline({reversed: true, paused:true})
		.set(this.button, {
			autoAlpha: 0,
			duration: 0.2,

		})
		.to(this.itemText, {
			height: "auto",
			duration: 0.5,
			autoAlpha: 1,
			ease: 'cubic.inOut',
		})
	}

	toggle() {
		if(!this.tl) {
			return;
		}
		this.tl.reversed() ? this.tl.play() : this.tl.reverse();
    }
}